import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">精彩片花</h2>
          <p className="text-sm text-foreground-500 mt-3">热门剧集精彩片段与独家花絮</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaData.map((item, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-[10px] text-foreground-200 font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-100 line-clamp-2 leading-snug">{item.title}</h3>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}